// extracted by mini-css-extract-plugin
module.exports = {"Stats":"Stats_Stats__1ZMns","Overlay":"Stats_Overlay__3AhPv","Content":"Stats_Content__3s-x-","Row":"Stats_Row__29J1n","Column":"Stats_Column__2Bq9z"};